angular.module('bmsApp.trugreen.job').controller('PrintInvoiceModalCtrl',
    function ($state,
              $modalInstance,
              $scope,
              TGInvoiceSvc) {


        $scope.cancel = function(){
            $modalInstance.dismiss('cancel');
        };

        $scope.confirm = function() {
            $modalInstance.close('ok');
        }

    });

